import { render, staticRenderFns } from "./Salaries.vue?vue&type=template&id=4c121a1d&"
import script from "./Salaries.vue?vue&type=script&lang=js&"
export * from "./Salaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports